<template>
  <div class="lender-card">
    <!-- Lender -->
    <div class="card shadow-lg card-hover-shadow ttransition-3d-hover card-bordered" style="border-width: 2px;">
      <div class="card-body">
        <div class="row py-2">
        <div class="col my-auto">
          <a :href="item.websiteUrl"><img class="iimg-fluid" :src="item.imageUrl" :title="item.lenderName" :alt="item.lenderName"></a>
        </div>
        <div class="col my-auto card-stat">
          <div class="font-size-2 strong">
            <span class="text-secondary font-size-1">Products</span><br />
            {{ item.products.totalProducts}}
          </div>
        </div>
        <div class="col my-auto card-stat">
          <div class="font-size-2">
            <span class="font-size-1 text-secondary">LTV</span><br />
            {{ item.products.ltvRange.min }} - {{ item.products.ltvRange.max }}%
          </div>
        </div>
        <div class="col my-auto card-stat">
          <div class="font-size-2">
            <span class="font-size-1 text-secondary">Interest Rates</span><br />
            {{ item.products.interestRateRange.min }} - {{ item.products.interestRateRange.max }}%
          </div>
        </div>
        <div class="col my-auto card-stat">
          <button class="btn-soft-success btn w-80 btn-sm">View Deals...</button>
        </div>
      </div>
      </div>
      <div v-if="keyPoints.length > 0" class="card-footer bg-light text-left text-black py-0">
        <ul class="list-unstyled list-inline mx-2 my-2 font-size-1">
          <li class="list-inline-item mr-3" v-for="item in keyPoints" :key="item">
            <span class="fas fa-check text-success"></span> {{ item }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<style scoped>
  div.card-stat {
    border-left: 1px solid #e0e0e0; 
    line-height: 1.6rem
  }

  .card-body {
    padding: 0.25rem !important;
  }

  ul li.key-points:before {
    content: '✓';
    color: #00c9a7;
    font-size: larger;
    font-weight: bolder;
  }
</style>

<script>
export default {
    name: "LenderCard",
  
    components: {
    },
    
    data() {
      return {
      }
    },

    props: {
      item: Object
    },
  
    computed: {
      keyPoints() {
        let a = [];
        
        if (this.item.top10LenderRanking != null) a.push("Top 10 UK Lender");
        if (this.item.isWhichRecommended === true) a.push("Which Recommended");
        if (this.item.ethicalRAG === "Medium" || this.item.ethicalRAG === "High") a.push("Ethical Lender");
        if (this.item.isContractorFriendly === true) a.push("Contractor Friendly Deals");
        
        return a;
      }
    }
};
</script>
